import React from "react"
import "./index.css"

const Changelog = (props) => (
  <div className={"change-log"}>
    <div className={`type ${props.type.toLowerCase()}`}>
      {props.type.toUpperCase()}
    </div>
    <div className={"content"}>
      <p>{props.children}</p>
    </div>
  </div>
)

export default Changelog



// WEBPACK FOOTER //
// ./src/components/changelog/Changelog.js